import { Pipe, PipeTransform } from '@angular/core';
import { lifecycleStages } from './lifecycle-stage';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Pipe({ name: 'stageName' })
export class LifecycleStageNamePipe implements PipeTransform {
  constructor(private readonly translate: TranslateService) {}
  transform(id: string): Observable<string> {
    const key = lifecycleStages.find((val) => val.id === id)?.translationKey || lifecycleStages[0].translationKey;
    return this.translate.stream(key);
  }
}
